import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import RadioButton from '../RadioButton/RadioButton';
import HorizontalRadioButton from '../RadioButton/HorizontalRadioButton';
import './RadioGroup.scss';

const RadioGroup = (props) => {
  const {
    radioButtons,
    selectedValue = radioButtons[0].value,
    onChange,
    underline,
    name,
    vertical,
  } = props;
  const handleOnChange = (targetValue) => {
    onChange(targetValue);
  };
  return vertical ? (
    <ul className="radio-button-group">
      {map(radioButtons, (radio, index) => (
        <li
          className={`radio-button ${underline ? 'radio-underline' : ''} ${radio.isSpecial ? 'special' : ''} ${name === 'plan' ? 'plan-radio-button' : ''}`}
          key={index}
        >
          <RadioButton
            {...radio}
            name={name}
            checked={radio.value === selectedValue}
            onChange={() => handleOnChange(radio.value)}
          />
        </li>
      ))}
    </ul>
  ) : (
    <div className="radio-button-group">
      <div className="row">
        {map(radioButtons, (radio, index) => (
          <div
            className="radio-separator-horizontal col-sm-6"
            key={index}
          >
            <div className={`radio-separator-horizontal-wrapper ${radio.value === selectedValue && 'selected'}`}>
              <HorizontalRadioButton
                {...radio}
                name={name}
                checked={radio.value === selectedValue}
                onChange={() => handleOnChange(radio.value)}
                description={'What\'s included:'}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

RadioGroup.propTypes = {
  radioButtons: PropTypes.arrayOf(PropTypes.object),
  selectedValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]),
  onChange: PropTypes.func,
  underline: PropTypes.bool,
  name: PropTypes.string.isRequired,
  vertical: PropTypes.bool
};

RadioGroup.defaultProps = {
  vertical: true
};

export default RadioGroup;



/** WEBPACK FOOTER **
 ** ./src/components/RadioGroup/RadioGroup.js
 **/